// core/mounter.ts — Platik-IA
// Inyección segura de Web Components en el DOM con error boundaries.

import { bus } from './event-bus';

export function mount(
  selector: string,
  tag: string,
  attrs: Record<string, string> = {}
): HTMLElement | null {
  const container = document.querySelector(selector);
  if (!container) {
    console.warn(`[mounter] Contenedor "${selector}" no encontrado`);
    return null;
  }

  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v);

  try {
    container.appendChild(el);
    return el;
  } catch (err) {
    bus.emit('app:error', { error: err as Error });
    console.error(`[mounter] Error montando <${tag}>:`, err);
    return null;
  }
}

export function unmount(selector: string): void {
  const el = document.querySelector(selector);
  el?.remove();
}

/** Reemplaza el loading inicial con el shell de la app */
export function removeBoot(): void {
  const boot = document.getElementById('boot-loading');
  if (boot) {
    boot.style.transition = 'opacity 0.3s ease';
    boot.style.opacity = '0';
    setTimeout(() => boot.remove(), 300);
  }
}
